import i18n from 'i18next';

import { isSupportedLanguage, storeLanguage } from './languages';

const applyLanguage = async (
  language: string | null | undefined
): Promise<void> => {
  if (!isSupportedLanguage(language)) {
    return;
  }

  storeLanguage(language);
  document.documentElement.lang = language;

  if (i18n.language !== language) {
    await i18n.changeLanguage(language);
  }
};

export default applyLanguage;
